import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { useMantenedorPermissions } from '../../hooks/useMantenedorPermissions';
import * as FaIcons from 'react-icons/fa';

/**
 * Layout simple y responsive para mantenedores
 * Sin SCSS, solo React-Bootstrap y estilos inline
 * Compatible con la estructura ControlGestion que funciona
 * Considera el sidebar fijo de 242px de ancho
 */
const SimpleMantenedorLayout = ({ 
  mantenedorId, 
  children, 
  title = "Mantenedor",
  subtitle,
  icon = <FaIcons.FaCog />,
  iconColor = "#007bff",
  showBackButton = true,
  breadcrumbs = []
}) => {
  const history = useHistory();
  const { checkPermission, isAuthenticated, getCurrentUser, permissionsLoading } = useMantenedorPermissions();
  const currentUser = getCurrentUser();
  
  // Hook para detectar el tamaño de ventana
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // console.log('Mantenedor ID:', mantenedorId);
  // console.log('Permisos de usuario:', checkPermission(mantenedorId));
  

  // Mostrar spinner mientras se cargan los permisos
  if (permissionsLoading) {
    return (
      <Container fluid className="pt-4 w-100">
        <Row className="gx-0" style={{ height: 'calc(100vh - 50px)' }}>
          <Col xs={12} className="d-flex align-items-center justify-content-center">
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <FaIcons.FaSpinner className="fa-spin" style={{ fontSize: '4rem', color: '#007bff', marginBottom: '20px' }} />
              <h2 style={{ color: '#212529', marginBottom: '16px' }}>Cargando permisos...</h2>
              <p style={{ color: '#6c757d', marginBottom: '24px' }}>
                Por favor espera mientras se verifican tus permisos.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  // Verificar autenticación
  if (!isAuthenticated()) {
    return (
      <Container fluid className="pt-4 w-100">
        <Row className="gx-0" style={{ height: 'calc(100vh - 50px)' }}>
          <Col xs={12} className="d-flex align-items-center justify-content-center">
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <FaIcons.FaExclamationTriangle 
                style={{ 
                  fontSize: '4rem', 
                  color: '#ffc107', 
                  marginBottom: '20px' 
                }} 
              />
              <h2 style={{ color: '#212529', marginBottom: '16px' }}>Acceso Denegado</h2>
              <p style={{ color: '#6c757d', marginBottom: '24px' }}>
                Debes iniciar sesión para acceder a esta sección
              </p>
              <button 
                style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => history.push('/auth')}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#007bff'}
              >
                Iniciar Sesión
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  // Verificar permisos específicos del mantenedor
  if (mantenedorId !== 'mantenedores' && !checkPermission(mantenedorId)) {
    return (
      <Container fluid className="pt-4 w-100">
        <Row className="gx-0" style={{ height: 'calc(100vh - 50px)' }}>
          <Col xs={12} className="d-flex align-items-center justify-content-center">
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <FaIcons.FaLock 
                style={{ 
                  fontSize: '4rem', 
                  color: '#dc3545', 
                  marginBottom: '20px' 
                }} 
              />
              <h2 style={{ color: '#212529', marginBottom: '16px' }}>Sin Permisos</h2>
              <p style={{ color: '#6c757d', marginBottom: '8px' }}>
                Hola {currentUser?.displayName || 'Usuario'}
              </p>
              <p style={{ color: '#6c757d', marginBottom: '24px' }}>
                No tienes permisos para acceder a {title}
              </p>
              <button 
                style={{
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => history.push('/mantenedores')}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
              >
                Volver a Mantenedores
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  const handleBackClick = () => {
    history.push('/mantenedores');
  };

  return (
    <>
      {/* Main content area */}
      <div 
        style={{
            margin: '0',
            paddingTop: '15px',
            minHeight: '100dvh',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflowX: 'hidden'
          }}
      >
        
        {/* Header Section */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '15px',
          border: '1px solid #dee2e6',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
            
            {/* Title and Icon */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '12px' 
            }}>
              <div style={{
                backgroundColor: iconColor,
                color: 'white',
                width: '48px',
                height: '48px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '1.2rem'
              }}>
                {icon}
              </div>
              <div>
                <h1 style={{ 
                  fontSize: '1.75rem', 
                  fontWeight: '600', 
                  color: '#212529', 
                  margin: '0',
                  fontFamily: 'Poppins, sans-serif'
                }}>
                  {title}
                </h1>
                {subtitle && (
                  <p style={{ 
                    fontSize: '1rem', 
                    color: '#6c757d', 
                    margin: '4px 0 0 0',
                    lineHeight: '1.4'
                  }}>
                    {subtitle}
                  </p>
                )}
              </div>
            </div>

            {/* Breadcrumbs */}
            <Breadcrumb style={{ 
              margin: '0',
              backgroundColor: 'transparent',
              padding: '0'
            }}>
              <Breadcrumb.Item 
                onClick={() => history.push('/mantenedores')}
                style={{ 
                  cursor: 'pointer',
                  color: '#007bff'
                }}
              >
                Mantenedores
              </Breadcrumb.Item>
              
              {breadcrumbs.map((crumb, index) => (
                <Breadcrumb.Item 
                  key={index}
                  active={index === breadcrumbs.length - 1}
                  onClick={crumb.path ? () => history.push(crumb.path) : undefined}
                  style={crumb.path ? { 
                    cursor: 'pointer',
                    color: '#007bff'
                  } : {}}
                >
                  {crumb.label}
                </Breadcrumb.Item>
              ))}
              
              {breadcrumbs.length === 0 && (
                <Breadcrumb.Item active>{title}</Breadcrumb.Item>
              )}
            </Breadcrumb>

            {/* Back Button */}
            {showBackButton && (
              <div style={{ marginTop: '12px' }}>
                <button
                  onClick={handleBackClick}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #dee2e6',
                    color: '#6c757d',
                    padding: '6px 12px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.borderColor = '#adb5bd';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.borderColor = '#dee2e6';
                  }}
                >
                  <FaIcons.FaArrowLeft style={{ fontSize: '10px' }} />
                  Volver
                </button>
              </div>
            )}
          </div>

          {/* Content Section */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            border: '1px solid #dee2e6',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            minHeight: 'calc(100vh - 200px)',
            overflow: 'auto'
          }}>
            <div style={{
              padding: '20px'
            }}>
              {children}
            </div>
          </div>

        </div>
      </>
    );
  };

  export default SimpleMantenedorLayout;
